import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { ArticleNumbersFieldComponent } from './article-numbers-field.component';
import { AutotrimDirective } from './directives/autotrim.directive';
import { HsCodeSelectorComponent } from './hscode-selector.component';
import { CompanyService } from './service/company.service';

@Component({
  selector: 'app-supply-chain-form-fields',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TranslateModule,
    AutotrimDirective,
    HsCodeSelectorComponent,
    ArticleNumbersFieldComponent,
  ],
  templateUrl: './supply-chain-form-fields.component.html',
  styleUrls: ['./supply-chain-form-fields.component.scss'],
})
export class SupplyChainFormFieldsComponent implements OnInit {
  @Input({ required: true }) form!: FormGroup;

  private readonly companyService = inject(CompanyService);

  /**
   * Scoped to the caller's own team by the server. Empty is a legitimate state — a team that has
   * never tagged anything, or the invitation flow, where the invitee has no vocabulary yet.
   */
  tagSuggestions: string[] = [];

  async ngOnInit() {
    // Suggestions are a convenience over free text, so a failed load must not block editing.
    this.tagSuggestions = await this.companyService.chainTagSuggestions().catch(() => []);
  }
}
